import { isAdminUserEmail } from "@-/dev.improve.haniverse.lib.admin.entities";
import { getAuthClient } from "@-/dev.improve.haniverse.lib.auth.client";

/**
 * Whether the Admin settings section should be shown.
 *
 * Always visible in development builds; on staging/production it's only shown
 * when the signed-in user's email is one of the admin accounts (see
 * `@-/dev.improve.haniverse.lib.admin.entities` — the maintainer account and the
 * shared `demo+admin@haniverse.app` demo/admin account), so the in-app dev tools
 * stay reachable on real deployed builds without shipping them to every user.
 */
export function useShowAdminSettingsSection(): boolean {
  const { data: session } = getAuthClient().useSession();
  if (__DEV__) {
    return true;
  }
  return isAdminUserEmail(session?.user?.email);
}
